import { useBackend } from "../../services";

export const useGetExchangeRateProducts = () => {
  const { get } = useBackend();
  const getExchangeRateProducts = () => get("products/exchangeRates");
  return { getExchangeRateProducts };
};
